import Vue from 'vue';

const resource = '/categories';

export default {
  // CUSTOM ENDPOINT
  getByCategoryType(idPublic) {
    return Vue.prototype.$axiosMainClient.get(
      `categorytypes/${idPublic}${resource}`
    );
  },
};
